import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import { Color } from '../../components/ThemeProvider/ThemeStyle';
import ManualUsersGuideConfig from './ManualUsersGuide/ManualUsersGuideConfig';

const titleMap = {
  manualCaregiversUrl: 'manual_caregiversGuide',
  manualParentsUrl: 'manual_parentsGuide'
};
const ManualModal = ({ onClose, classes, selectedInstructionKey, t, language }) =>
  selectedInstructionKey ? (
    <Dialog maxWidth="lg" open={true} onClose={onClose} classes={classes}>
      <div className="p2 fs-16 fw-6">{t(titleMap[selectedInstructionKey])}</div>
      <object
        style={{ height: '100vh', width: '100%' }}
        data={ManualUsersGuideConfig[selectedInstructionKey][language]}
      >
        <div className="bold center p3" style={{ color: Color.secondary }}>
          {t('manual_canNotViewFile')}
        </div>
      </object>
    </Dialog>
  ) : null;

export default ManualModal;
